/**
 * TITLE SHEET round (2026-10-03): the G001 title sheet's live content — project summary tables,
 * notes, jurisdiction, code analysis, scope of work, directory, vicinity map and sheet index —
 * MIRRORED into the model doc as one plain "facts" object so the sheet renders synchronously,
 * offline, identically on every peer and in the PDF export. Same mirror-at-source pattern as
 * projectInfo.ts / siteNotes.ts: Airtable stays the source of truth (fetched through
 * api/title-sheet.js on every editable open), the doc carries a resolved copy, and it is never
 * hand-edited in the Modeler — fix the record and reopen. The layout + every show/hide rule lives
 * in frontend/src/bim/sheets/titleSheet.js; this file only stores and returns the facts.
 *
 * One settings-map key, the siteSettings/projectInfo pattern. Shape: see api/title-sheet.js.
 */
import type { ModelDoc } from './doc'
import { maps, transact } from './doc'

const TITLE_SHEET_KEY = 'titleSheetData'

export type TitleSheetData = Record<string, unknown> & { v?: number; fetchedAt?: string }

export function getTitleSheetData(model: ModelDoc): TitleSheetData | null {
  const v = maps(model).settings.get(TITLE_SHEET_KEY)
  return v && typeof v === 'object' ? (v as TitleSheetData) : null
}

export function setTitleSheetData(model: ModelDoc, data: TitleSheetData | null): void {
  transact(model, () => {
    if (data) maps(model).settings.set(TITLE_SHEET_KEY, data)
    else maps(model).settings.delete(TITLE_SHEET_KEY)
  })
}
